import axios from 'axios';
import auth from '@/plugins/auth-service';
import { i18n } from '@/plugins/i18n';

const axiosApi = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_PATH,
});

axiosApi.interceptors.request.use(async (config) => {
  config.headers['Authorization'] = 'Bearer ' + (await auth.getAccessToken());
  config.headers['Accept-Language'] = i18n.locale;

  return config;
});

export default axiosApi;
